import type { PaymentFlowStore } from '../../../state/payment-stores/payment-flow-store';

export interface PlaceOrderButtonTextInput {
  currentState: PaymentFlowStore['currentState'];
  hasRetryableFailure: boolean;
  /** Pricing failed and the button now offers a reprice. */
  isPricingRetry: boolean;
  /** Pricing or the delivery quote is still in flight. */
  isPricingLoading: boolean;
  /** Pricing has definitively failed — nothing is still loading, so never show a loading label. */
  hasPricingFailure: boolean;
  serverOrderStatus?: string;
}

export function getPlaceOrderButtonText({
  currentState,
  hasRetryableFailure,
  isPricingRetry,
  isPricingLoading,
  hasPricingFailure,
  serverOrderStatus,
}: PlaceOrderButtonTextInput) {
  if (isPricingLoading && !hasPricingFailure) {
    return 'Loading Prices...';
  }
  if (serverOrderStatus === 'INSERT_REQUESTED') {
    return 'Sending to Store...';
  }
  if (isPricingRetry) {
    return 'Try Again';
  }
  if (hasRetryableFailure) {
    return 'Retry Place Order';
  }
  switch (currentState) {
    case 'encrypting':
      return 'Encrypting...';
    case 'validatingCart':
      return 'Checking Cart...';
    case 'serviceModeCheck':
    case 'committing':
    case 'vaulting':
      return 'Processing Order...';
    case 'confirming':
      return 'Confirming Order...';
    default:
      return 'Place Secure Order';
  }
}
